import { MutationTree } from 'vuex';

import { decode, encode } from '@/utils/custom-enc-dec';

import {
  AuthStateI,
  PermissionI,
  GoogleUserI,
  GoogleProjectI,
  UserI,
} from './state';

export const mutations: MutationTree<AuthStateI> = {
  setProjects(state: AuthStateI, payload: GoogleProjectI[]) {
    // convert the payload object to array
    const projectsArr = Object.values(payload);
    if (projectsArr.length === 0) {
      localStorage.removeItem('projects');
      state.projects = [];
      return;
    }
    const projects = encode(projectsArr);
    localStorage.setItem('projects', projects);
    state.googleProjects = projectsArr;

    const project = localStorage.getItem('project');
    if (!project) {
      const selectedProject = projectsArr[0];
      state.googleProject = selectedProject;
      localStorage.setItem('project', encode(selectedProject));
    }
  },
  setProject(state: AuthStateI, payload: GoogleProjectI) {
    const project = encode(payload);
    localStorage.setItem('project', project);
    state.googleProject = payload;
  },
  setPermissions(state: AuthStateI, payload: string) {
    if (payload.length === 0) {
      localStorage.removeItem('permissions');
      state.permissions = [];
      return;
    }
    const { value } = decode(payload);
    localStorage.setItem('permissions', payload);
    state.permissions = value as unknown as PermissionI[];
  },
  setToken(state: AuthStateI, payload: string) {
    if (!payload) {
      localStorage.removeItem('token');
      state.token = '';
      return;
    }
    const { value } = decode(payload);
    localStorage.setItem('token', payload);
    state.token = value as unknown as string;
  },
  setUser(state: AuthStateI, payload: string) {
    if (!payload) {
      localStorage.removeItem('user');
      state.user = undefined;
      return;
    }

    const { value } = decode(payload);
    localStorage.setItem('user', payload);
    state.user = value as unknown as UserI;
  },
};
